import React from 'react';

// Steps or points in order, each with its number in a circle, such as a "how it works" list. items are the texts,
// strings or elements, in their order.
export default function NumberedList({ items = [] }) {
  return (
    <ol className='numlist'>
      {items.map((item, index) => (
        <li
          key={index}
          className='numlist-item'
        >
          <span className='numlist-num'>{index + 1}</span>
          <div>{item}</div>
        </li>
      ))}
    </ol>
  );
}
